<div class="modal-header border-0 pb-1 align-items-start">
  <div class="w-100">
    <div class="fw-bold fs-5">Assign Study Unit Practice Test</div>

  </div>
  <button type="button"
          class="btn-close ms-3 mt-2"
          aria-label="Close"
          (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body pt-0">
  <div class="table-responsive">
    <table class="table align-middle">
      <thead>
        <tr>
          <th scope="col">StudyUnit ID</th>
          <th scope="col">Topic</th>
          <th scope="col">Study Unit Name</th>

        </tr>
      </thead>
      <tbody>
        <tr
        *ngFor="let unit of studyUnits"
        (click)="highlightUnit(unit.Study_Unit_Id)"
        (dblclick)="selectUnit(unit.Study_Unit_Id)"
        [class.table-active]="unit.Study_Unit_Id === highlightedUnitId"
        [class.selected]="unit.Study_Unit_Id === selectedUnitId"
        style="cursor: pointer"
        title="Double click to select"
      >
          <td>{{ unit.Study_Unit_Id }}</td>
          <td>{{ unit.Path_Name }}</td>
          <td>{{ unit.Study_Unit_Name }}</td>

        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer border-0 pt-0">
  <button class="btn bl-btn px-4" (click)="save()">Select</button>
  <button class="btn btn-light border" (click)="activeModal.dismiss()">Cancel</button>
</div>
